export { default as LoyaltyFeaturedRewardsCarouselWidget } from './loyalty-featured-rewards-carousel-widget';
